import css from './lifMonitoring.module.css'
import { memo } from 'react'
import { useParams } from 'react-router-dom'
import useEquipment from '@/pages/Equipment/hooks/useEquipment.ts'
import MainLayout from '@/shared/Layouts/MainLayout'
import NavigationBreadcrumbs from '@/navigation/components/NavigationBreadcrumbs'
import urls from '@/navigation/urls.ts'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'
import AntDatePicker from 'src/shared/Inputs/DatePickers/AntDatePicker'
import MonitoringTabContent from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/MonitoringTabContent'
import useTitle from '@/shared/hooks/useTitle'
import usePlayerWidget from './usePlayerWidget'
import Segmented from '@/shared/Common/Segmented'
import useMonitoringModeCtrl from './useMonitoringModeCtrl'
import PlayerWidget from './PlayerWidget'
import cn from '@/utils/cn'

const LiftMonitoring = () => {
  const liftId = +useParams().id
  const equipment = useEquipment(+liftId)
  useTitle(
    equipment
      ? `Мониторинг — ${equipmentUtils.getEquipmentAddress(equipment.location, {
          includeCountry: false,
          includeCity: true,
          includeRegion: false,
          includeAddress: true,
        })}`
      : 'Мониторинг'
  )

  const playerCtrl = usePlayerWidget()
  const modeCtrl = useMonitoringModeCtrl()

  const renderPicker = () => {
    switch (modeCtrl.timeSelectionMode) {
      case 'point':
        return (
          <AntDatePicker
            size="large"
            style={{ width: '200px' }}
            selectedTs={modeCtrl.selectedDate.getTime()}
            onChange={modeCtrl.handleDateSelect}
            withTime={true}
            allowSelectInFuture={false}
            format="DD.MM.YYYY HH:mm:ss"
          />
        )

      case 'range':
        return <PlayerWidget ctrl={playerCtrl} />
    }
    return null
  }

  const renderModeInputs = () => {
    return (
      <div className="inline-flex-gap gap16 width100" style={{ justifyContent: 'end' }}>
        {renderPicker()}
        <div style={{ flexShrink: 0 }}>
          <Segmented
            size="large"
            style={{ width: 'fit-content ' }}
            block
            options={[
              { value: 'range', label: 'Период' },
              { value: 'point', label: 'Момент' },
              { value: 'live', label: 'Онлайн' },
            ]}
            value={modeCtrl.timeSelectionMode}
            onChange={modeCtrl.handleTimeSelectionMode}
          />
        </div>
      </div>
    )
  }

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <NavigationBreadcrumbs
          withBackButton={true}
          crumbs={[
            { id: 1, to: null, title: 'Оборудование' },
            {
              to: urls.liftScreen(equipment.id),
              id: 2,
              title: equipmentUtils.getEquipmentAddress(equipment.location),
              replace: true,
            },
            { id: 3, title: 'Мониторинг', to: null },
          ]}
        />
        <div className="inline-flex-gap gap32 mt16 width100" style={{ justifyContent: 'space-between' }}>
          <h3 className={cn('text-heading-3', css.title)}>Мониторинг</h3>
          {renderModeInputs()}
        </div>

        <MonitoringTabContent
          contentType={modeCtrl.timeSelectionMode}
          selectedDate={modeCtrl.selectedDate}
          equipmentId={liftId}
          tsFrom={playerCtrl.tsFrom}
          tsTo={playerCtrl.tsTo}
          tsCurrent={playerCtrl.tsCurrent}
          onSelectedTabChanged={playerCtrl.stop}
        />
      </div>
    </MainLayout>
  )
}

export default memo(LiftMonitoring)
